import { render, staticRenderFns } from "./ProjectTablesDashboard.vue?vue&type=template&id=1c2e7928&lang=pug&"
import script from "./ProjectTablesDashboard.vue?vue&type=script&lang=js&"
export * from "./ProjectTablesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTablesDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports